<template>
  <div class="icono-libre">
    <svg
      v-if="!plazasLibresRepercutidas && !rooming"
      width="60"
      height="60"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.7036 24.3012C39.7036 19.476 35.7612 15.5503 30.9153 15.5503C26.0694 15.5503 22.0449 19.476 22.0449 24.3012C22.0449 27.5726 23.8518 30.4351 26.4801 31.9072C21.2235 33.6247 17.2811 38.3682 16.7062 44.0931C16.5419 45.5652 19.3345 45.647 19.4987 44.2567C20.0737 38.45 25.0017 34.0336 30.9153 34.0336C36.7468 34.0336 41.7569 38.45 42.3318 44.2567C42.414 45.647 45.2065 45.5652 45.0422 44.0931C44.5494 38.2864 40.607 33.6247 35.2684 31.9072C37.8966 30.4351 39.7036 27.5726 39.7036 24.3012ZM24.7969 24.2842C24.7969 20.978 27.5244 18.2505 30.9132 18.2505C34.2193 18.2505 36.9469 20.978 36.9469 24.2842C36.9469 27.6729 34.2193 30.4005 30.9132 30.4005C27.5244 30.4005 24.7969 27.6729 24.7969 24.2842Z"
        fill="var(--landing-detail-color, var(--bs-primary))" />
      <circle
        cx="31"
        cy="31"
        r="30"
        stroke="var(--landing-detail-color, var(--bs-primary))"
        stroke-width="2"
        stroke-dasharray="6 6" />
    </svg>
    <svg
      v-if="rooming && !plazasLibresRepercutidas"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11.5" fill="#F9F7F8" stroke="#8D8D9E" />
      <path
        d="M11.9961 12C14.0672 12 15.7461 10.3211 15.7461 8.25C15.7461 6.17893 14.0672 4.5 11.9961 4.5C9.92503 4.5 8.24609 6.17893 8.24609 8.25C8.24609 10.3211 9.92503 12 11.9961 12Z"
        stroke="#8D8D9E"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M18.4475 19.5C18.4475 16.5975 15.56 14.25 12.005 14.25C8.45 14.25 5.5625 16.5975 5.5625 19.5"
        stroke="#8D8D9E"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>

    <svg
      v-if="plazasLibresRepercutidas"
      width="60"
      height="60"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.3362 15.8023C26.3362 12.5857 23.708 9.96875 20.4774 9.96875C17.2468 9.96875 14.5638 12.5857 14.5638 15.8023C14.5638 17.983 15.7684 19.8912 17.5206 20.8725C14.0162 22.0174 11.3879 25.1795 11.0046 28.9959C10.8951 29.9772 12.7568 30.0317 12.8663 29.1049C13.2496 25.2341 16.535 22.29 20.4774 22.29C24.365 22.29 27.7051 25.2341 28.0884 29.1049C28.1432 30.0317 30.0049 29.9772 29.8954 28.9959C29.5668 25.125 26.9385 22.0174 23.3794 20.8725C25.1316 19.8912 26.3362 17.983 26.3362 15.8023ZM16.3984 15.7917C16.3984 13.5878 18.2168 11.7695 20.476 11.7695C22.6801 11.7695 24.4984 13.5878 24.4984 15.7917C24.4984 18.0507 22.6801 19.8689 20.476 19.8689C18.2168 19.8689 16.3984 18.0507 16.3984 15.7917Z"
        fill="var(--blue-1)"
        fill-opacity="0.25" />
      <circle cx="20" cy="20" r="20" fill="var(--blue-1)" fill-opacity="0.15" />
      <circle cx="20" cy="20" r="19.25" stroke="var(--blue-1)" stroke-opacity="0.25" stroke-width="1.5" />
    </svg>
  </div>
</template>

<script setup>
  defineProps({
    plazasLibresRepercutidas: {
      type: Boolean,
      default: false,
    },
    rooming: {
      type: Boolean,
      default: false,
    }
  });
</script>

<style scoped>
  .icono-libre {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
